const AUDIO_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[audioManagementExperience] createAudio',
  EDIT: '[audioManagementExperience] editAudio'
}

export default AUDIO_MANAGEMENT_EXPERIENCE_TYPES
